import React from 'react';
import '../../ElectricFuelPages/ElectricFuel.scss';

interface ViewDetailsProps {
  customerData: any;
}

const ViewDetails: React.FC<ViewDetailsProps> = ({ customerData }) => {
  const fields = [
    { label: 'Company', value: customerData.vendor_company, icon: 'fa fa-building' },
    { label: 'Name', value: customerData.vendor_name, icon: 'fa fa-user' },
    { label: 'PAN No.', value: customerData.pan_no, icon: 'fa fa-id-card' },
  ];

  return (
    <div className="p-4">
      <div className="detail-view-avatar">
        <i className="fa fa-building"></i>
      </div>
      <div className="columns is-multiline">
        {fields.map((field, idx) => (
          <div className="column is-6" key={idx}>
            <div className="detail-view-field">
              <p className="detail-view-label">
                <i className={`${field.icon} mr-1`}></i> {field.label}
              </p>
              <p className="detail-view-value">{field.value || '—'}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewDetails;
